import * as UI from "@accurx/design";
import styled from "styled-components";

export const Text = styled.span<{ $colour?: string }>`
    ${UI.Tokens.TYPOGRAPHY.body.base}

    font-weight: 700;
    color: ${({ $colour = UI.Tokens.COLOURS.greyscale.zinc }) => $colour};
`;
